import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

import useInterceptors from '../interceptor';
import squareInterceptor from '../interceptor/interceptors/square';

const API: AxiosInstance = useInterceptors(Axios.create(), [
  squareInterceptor,
]);

const Endpoint = EndpointFactory(API);

// order form
const orderForm = 'posts/orderform';
export const orderFormByGuid = new Endpoint<{ guid: string }>(({ guid }) => `${orderForm}/${guid}?fields=content`);
